export default __webpack_public_path__ + "static/flag-it-0f7f5dd761a9cd752c92b991f0169375.svg";